export const FETCH_VIDEOS = "FETCH_VIDEOS"
export const GET_VIDEO = "GET_VIDEO"
export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const LOGOUT = "LOGOUT"
export const AUTH_ERROR = "AUTH_ERROR"
export const VALIDATE_ERROR = "VALIDATE_ERROR" 
export const VALIDATE_INIT = "VALIDATE_INIT" 
export const SAVE_INIT = "SAVE_INIT" 
export const SAVE_ERROR = "SAVE_ERROR" 
